import { defineMessages } from 'react-intl';

export default defineMessages({
    locationHeading: {
        id: "claims.wizard.commercial.TWIA.Location.Heading",
        defaultMessage: "Location"
    },
    territoryCodeHeading: {
        id: "claims.wizard.commercial.TWIA.Location.Accordion.Territory Code",
        defaultMessage: "Territory Code"
    },
    countyHeading: {
        id: "claims.wizard.commercial.TWIA.Location.Accordion.County",
        defaultMessage: "County"
    },
    fullAddressHeading: {
        id: "claims.wizard.commercial.TWIA.Location.Accordion.Full Address",
        defaultMessage: "Full Address"
    },
    editLocation: {
        id: "claims.wizard.commercial.TWIA.Location.Edit Location",
        defaultMessage: "Edit Location"
    },
    premiumInfo: {
        id: "claims.wizard.commercial.TWIA.Location.Total Premium including Credits And Surcharges",
        defaultMessage: "Total Premium including Credits And Surcharges: {totalPremium}"
    },
    buildingAndLocation:{
        id: "claims.summary.commercial.Building and Location Details",
        defaultMessage: "Building and Location Details"
    },
    coverages:{
        id: "claims.summary.commercial.Location.Coverages",
        defaultMessage: "Coverages"
    }
})